// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"bc60a453","156":"097d0179","341":"d04918e4","438":"39bbd81a","706":"8a34610b","726":"efc427f2"}[chunkId] + ".chunk.js";
};